import React from 'react';
import MinimalDumbo from '../../../DeviationViews/Dumbo/EditorDumbo';
import { Props } from '../ThumbView';

const ImageThumbView: React.FC<Props> = (props: Props) => {
  /* In editor we make the background transparent to avoid overlapping with custom backgrounds */
  return <MinimalDumbo useBackgroundColor={false} {...props} />;
};
ImageThumbView.displayName = 'ImageThumbView';

export default ImageThumbView;
